import { createContext } from "react";

import { IdentitySearchQuery } from "../types/search-display";

type IdentitySearchQueryContextType = {
  identitySearchQueryState: IdentitySearchQuery;
  setIdentitySearchQueryState: React.Dispatch<
    React.SetStateAction<IdentitySearchQuery>
  >;
};

export const IdentitySearchQueryContext =
  createContext<IdentitySearchQueryContextType>(
    {} as IdentitySearchQueryContextType
  );
